import { Button } from '@mantine/core';
import Link from 'next/link';

type ViewProps = {
  url: string;
};
export const View = ({ url }: ViewProps) => {
  return (
    <Link href={url} style={{ textDecoration: 'none' }} target='_blank'>
      <Button variant='transparent'>View</Button>
    </Link>
  );
};
